import React, {useEffect, useContext} from 'react';
import { Wizard, Steps, Step } from 'react-albus';
import Approval from './Approval';
import CompletingDetails from './CompletingDetails';
import PersonalInfo from './PersonalInfo';
import PreEducation from './PreEducation';
import ProgramSelection from './ProgramSelection';
import StepsIndicator from './StepsIndicator'
import RegisterContext from '../RegisterContext';

export default function StepsRegistration({labels}) {

  const {loadUserDetails} = useContext(RegisterContext)

  useEffect(() => {
    loadUserDetails
  }, [])

  return (
      <div>
        <Wizard render={({ step, steps,push, previous }) => (
          <React.Fragment>
            <StepsIndicator steps={steps} step={step} labels={labels} push={push} previous={previous}/>
            <Steps>
              <Step
                  id="personal_info"
                  render={({ next}) => (
                  <PersonalInfo labels={labels} next={next} />
                  )}
              />
              <Step
                  id="program_selection"
                  render={({ next }) => (
                  <ProgramSelection labels={labels} next={next} />
                  )}
              />
              <Step
                  id="pre_education"
                  render={({ next }) => (
                  <PreEducation labels={labels} next={next} />
                  )}
              />
              <Step
                  id="completing_details"
                  render={({ next }) => (
                  <CompletingDetails labels={labels} next={next} />
                  )}
              />
              <Step
                  id="approval"
                  render={({ next }) => (
                  <Approval labels={labels} next={next} />
                  )}
              />
          </Steps>
          </React.Fragment>
        )}>

        </Wizard>
      </div>
  )
}